module.exports = __webpack_public_path__ + "static/media/8b01637a-f445-4f10-92ea-b84a355f7690.2bd3ab23.woff";